import React from 'react'
import styled from 'styled-components'
import map from 'lodash/map'
import get from 'lodash/get'
import xor from 'lodash/xor'

const Type = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0;
  width: 100%;
  background: ${props => props.background ? props.background : 'rgba(0, 0, 0, 0.10)'};
  padding: 2px;
  margin-bottom: 10px;

  & > div {
    padding-right: 20px;
    display: flex;
    align-items: center;
  }

  & span {
    font-weight: 600;
    padding-right: 20px;
  }

  & label {
    padding-top: 2px;
    cursor: pointer;
  }
`

const Wrapper = styled.section`
  background: ${props => props.background ? props.background : 'aquamarine'};
  padding: 0px;
  margin-bottom: 15px;
`

class HideColumn extends React.PureComponent {

  render() {
    const {
      columnList = [],
      hideColumn = [],
      getHideColumn,
      name = 'Show Column'
    } = this.props

    return (
      <Wrapper background={this.props.background}>
        <Type background={this.props.background}>
          <span>{name === 'NotDefault' ? '' : name + ':'}</span>

          {map(columnList, obj => {
            const key = get(obj, 'key')
            const title = get(obj, 'title')

            return (
              <div key={key}>
                <input
                  type="checkbox"
                  id={key}
                  style={{ marginRight: '5px' }}
                  checked={hideColumn.includes(key)}
                  onChange={() => {
                    getHideColumn(xor(hideColumn, [key]), key)
                  }}
                />
                <label htmlFor={key}>{title}</label>
              </div>
            )
          })}
        </Type>
      </Wrapper>
    )
  }
}

export { HideColumn }